import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const GuestHeader = () => {
    const { t } = useTranslation();
    const lang = localStorage.getItem('lang');
    localStorage.setItem('lang', lang === null ? 'en' : lang);
    // window.location.reload();
    const updateAppLang = (newLang) => {
        localStorage.setItem('lang', newLang);
        window.location.reload();
    }
    return (
        <div className='guest-header'>
            <div className="d-flex jcsb align-items-center text-white">
                <div className='guest-header-logo'>
                    <img src="/logo.png" alt="" className='mx-2' />
                </div>
                <div className='mx-3 text-white'>
                    <Link to=""
                        onClick={() => {
                            updateAppLang(lang === "en" ? 'ar' : 'en');
                        }}
                        className='m-2'>{lang === "en" ? 'عربي' : 'English'}</Link>
                    <Link to='/' className='mx-2'>{t('login')}</Link>
                    {/* <Link to='/regsiter/student' className='mx-2'>{t('register')}</Link> */}
                </div>
            </div>
            {/* <h5>Header</h5> */}
        </div>
    );
}
export default GuestHeader;